import React from "react";
import "./../styles/Features.css";

// Icons
import { MdGroups } from "react-icons/md";
import { IoAnalytics } from "react-icons/io5";
import { GrTechnology } from "react-icons/gr";

// Images
import system from "./../assets/1-1.png";

const Features = () => {
  return (
    <div id="scrollspyfeature" className="container-fluid pt-3 pt-lg-5">
      <div className="pt-5">
        <div className="container text-center">
          <div className="row">
            <div className="col-md-6">
              <img src={system} className="img-fluid" alt="PesoPulse System" />
            </div>
            <div className="col-md-6">
              <h4 className="fw-semibold text-secondary text-start">
                What is PesoPulse?
              </h4>
              <p className="text-start text-secondary customFont">
                Pesopulse is an intuitive accounting platform equipped with
                advanced features tailored to streamline financial management
                tasks. With its OCR technology, users can easily input income
                and expense data by scanning and extracting information from
                various documents. Additionally, Pesopulse's robust analytics
                capabilities provide valuable insights and recommendations based
                on analyzed financial data, facilitating informed
                decision-making for individuals and businesses.
              </p>
              <div className="d-grid gap-2 d-md-flex justify-content-md-start">
                <a className="btn fs-6 me-md-2 customButton" href="https://fb.watch/rnKJji2tMR/" type="button">
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="py-4">
        <h4 className="pt-3 text-secondary fw-semibold">Features</h4>
        <p className="text-secondary">
          Here are some key features of PesoPulse
        </p>
        <div className="row pt-3">
          <div className="col-md-4 mb-4">
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="icons">
                  <MdGroups />
                </div>
                <div>
                  <p className="text-secondary">
                    <strong>Team collaboration</strong> in Pesopulse involves seamless
                    communication and coordination among multiple users,
                    allowing for efficient sharing of financial data and tasks
                    to streamline accounting processes.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="icons">
                  <GrTechnology />
                </div>
                <div>
                  <p className="text-secondary">
                    Pesopulse, <strong>OCR (Optical Character Recognition) technology</strong>
                    serves as a pivotal tool, enabling users to effortlessly
                    extract and input financial data from various sources such
                    as receipts, invoices, and documents
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="icons">
                  <IoAnalytics />
                </div>
                <div>
                  <p className="text-secondary">
                    Pesopulse's analytics feature <strong>incorporates a recommendation
                    system</strong> that provides users with actionable insights and
                    suggestions based on their financial data, empowering
                    informed decision-making for better financial management.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
